import { useMemo } from 'react';

interface TimelineItemHeaderProps {
  filename: string;
}

export function TimelineItemHeader({ filename }: TimelineItemHeaderProps) {
  const style = useMemo(() => {
    // text shadow가 잘리는 것을 방지
    return {
      padding: 10,
      marginLeft: 0,
      marginRight: 0,
      marginTop: -10,
      marginBottom: -10,
      // textShadow: '0 0 10px black, 0 0 10px black, 1px 1px 1px black',
    };
  }, []);

  return (
    <div
      className="pointer-events-none absolute top-0 flex h-20 w-full items-start"
      title={filename}
    >
      <span
        className="truncate px-[10px] text-xs text-comp-accent-xxsmall font-medium text-sys-cont-inverse-dark"
        style={style}
      >
        {filename}
      </span>
    </div>
  );
}
